/**
 * Post-import / dashboard counts for freshling flyers (parallel to mentor pipeline summary).
 */

import { isWithdrawnOrDuplicate } from './tshirtRosterEligibility';

function isWaitingFreshling(flyer) {
  if (!flyer || flyer.type !== 'freshling') return false;
  if (flyer.waiting) return true;
  const st = (flyer.status || '').toString().toLowerCase();
  return st.includes('wait');
}

/**
 * @param {object[]} flyers
 */
export function computeFreshlingPipelineSummary(flyers) {
  const freshlings = (flyers || []).filter((f) => f && f.type === 'freshling' && !f.test);
  let active = 0;
  let waitingList = 0;
  let cancelled = 0;
  let withdrawnOrDuplicate = 0;
  for (const fl of freshlings) {
    if (fl.cancelled) {
      cancelled++;
      continue;
    }
    if (isWaitingFreshling(fl)) {
      waitingList++;
      continue;
    }
    if (isWithdrawnOrDuplicate(fl)) {
      withdrawnOrDuplicate++;
      continue;
    }
    active++;
  }
  return {
    active,
    waitingList,
    cancelled,
    withdrawnOrDuplicate,
    total: freshlings.length,
  };
}
